import React from 'react';
import './TypingAnimation.css';

const TypingAnimation = () => {
  return (
    <div className="typing-animation">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default TypingAnimation; 